import { render, staticRenderFns } from "./batchChooseModal.vue?vue&type=template&id=592f9709&scoped=true"
import script from "./batchChooseModal.vue?vue&type=script&lang=js"
export * from "./batchChooseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592f9709",
  null
  
)

export default component.exports